import {WorkspaceCalendarPanel} from "./workspaceCalendarPanel";
import {IntegrationType} from "@/shared/timrTypes";

export class Google extends WorkspaceCalendarPanel {

	private static INTEGRATION_URL: string;

	public static setIntegrationUrl(url: string) {
		Google.INTEGRATION_URL = url;
	}

	public static getIntegrationUrl(): string {
		return Google.INTEGRATION_URL;
	}

	protected get integrationType(): IntegrationType {
		return IntegrationType.GOOGLE;
	}

	protected get integrationUrl(): string {
		return Google.getIntegrationUrl();
	}
}
